import { registerBlockType } from "@wordpress/blocks";
import { __ } from "@wordpress/i18n";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./edit";
import "./style.scss";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="4.1"
          y="4.1"
          width="6.8"
          height="6.8"
          rx="1.4"
          stroke="currentColor"
          stroke-width="1.2"
        />
        <rect
          x="13.1"
          y="4.1"
          width="6.8"
          height="6.8"
          rx="3.4"
          stroke="currentColor"
          stroke-width="1.2"
        />
        <rect
          x="4.1"
          y="13.1"
          width="6.8"
          height="6.8"
          rx="1.4"
          stroke="currentColor"
          stroke-width="1.2"
        />
        <rect
          x="13.1"
          y="13.1"
          width="6.8"
          height="6.8"
          rx="1.4"
          stroke="currentColor"
          stroke-width="1.2"
        />
      </svg>
    ),
  },
  example: {
    attributes: {
      iconName: "ph-github-logo",
      iconType: "regular",
      iconSize: "32",
      iconColorValue: "#0061FE",
      backgroundColor: "#0061FE",
    },
  },
});
